//#region src/worldpay_market_code.ts
var WorldpayMarketCode = /* @__PURE__ */ function(WorldpayMarketCode) {
	WorldpayMarketCode["FoodRestaurant"] = "FoodRestaurant";
	WorldpayMarketCode["Retail"] = "Retail";
	return WorldpayMarketCode;
}(WorldpayMarketCode || {});
//#endregion
export { WorldpayMarketCode };

//# sourceMappingURL=worldpay_market_code.js.map